import { randomStr, token } from './random'

/**
 * 生成随机不重复的 Key
 */
export function* keyGenerator() {
  const prefixed = randomStr(5, token.alphabet)
  let key = 0

  while (true) {
    yield `${prefixed}_${key++}`
  }
}

const generator = keyGenerator()
export function getKey<T>(...args: T[]): string
export function getKey() {
  return generator.next().value
}
